import React from 'react';
import { useSelector } from 'react-redux';
import { getLandingPageCreatorStore } from '@/store/landingPageCreator/actions';
import { SocialPreview } from '../../components/SocialPreview';

export const Step4Content = (): JSX.Element => {
    const { landingPageObject, landingPagePayload, landingPageMetaDataObject, landingPageMetaDataPayload } = useSelector(getLandingPageCreatorStore);

    const imageUrl = landingPageMetaDataPayload?.data?.socialPreview?.imageUrl ?? landingPageMetaDataObject?.data?.socialPreview?.imageUrl;
    const pageTitle = landingPageMetaDataPayload?.data?.socialPreview?.pageTitle ?? landingPageMetaDataObject?.data?.socialPreview?.pageTitle;
    const pageDescription = landingPageMetaDataPayload?.data?.socialPreview?.pageDescription ?? landingPageMetaDataObject?.data?.socialPreview?.pageDescription

    return (
        <SocialPreview 
            pageUrl={landingPageObject?.LandingUrl ?? landingPagePayload?.LandingUrl}
            imageUrl={imageUrl}
            pageTitle={pageTitle}
            pageDescription={pageDescription}
        />
    );
};
